import color from 'color';
import moment from 'moment';

import { Story as API } from '@src/api/types';
import { baseURL } from '@src/configuration/constants';
import { Story as Data } from '@src/types';

import generatePlaceTag from './placeTag';
import generateUser from './user';

const Factory = (api: API): Data => ({
  type: api.containedEntityType,
  color:
    api.backgroundColor?.colorMode === 'DECIMAL'
      ? color(parseInt(api.backgroundColor?.color ?? 4868682, 10)).hex()
      : color(api.backgroundColor?.color ?? 4868682).hex(),
  cover:
    api.containedEntityType === 'MAP_RENDER'
      ? { source: { uri: api.background }, type: 'PHOTO' }
      : api?.checkIn?.medias?.[0]?.mediaType === 'VIDEO'
      ? {
          source: {
            uri: `${baseURL}/media/v1/video/stream/${api?.checkIn?.medias?.[0].mediaName}`,
          },
          type: 'VIDEO',
        }
      : {
          source: {
            uri: `${baseURL}/media/v1/image/${api?.checkIn?.medias?.[0].mediaName}`,
          },
          type: 'PHOTO',
        },
  date: moment.unix(api.date / 1000),
  place: generatePlaceTag(api.business),
  content: api?.checkIn?.description,
  id: api.id,
  user: generateUser(api.user),
  postId: api?.checkIn?.id,
});

export default Factory;
